import { Schema as S } from "effect";

export const ChatHistoryMessage = S.Struct({
	role: S.Literals(["user", "assistant"]),
	content: S.String,
});
export type ChatHistoryMessage = typeof ChatHistoryMessage.Type;
